export default "__VITE_ASSET__DHhH8eVS__"